<div class="gw-border-base gw-bg-background-elevation-2 gw-overflow-hidden">
  <!-- Header -->
  <div
    class="gw-flex gw-items-center gw-justify-between gw-px-medium gw-py-medium gw-cursor-pointer"
    (click)="toggleExpanded()"
  >
    <div
      class="gw-flex gw-items-center gw-gap-2x-small gw-cursor-pointer"
      (click)="toggleExpanded()"
    >
      <gatewee-icon icon="@phi.funnel" size="16px" weight="bold"></gatewee-icon>
      <span class="gw-text-text-primary gw-text-sm gw-font-semibold">
        {{ 'common.filters.title' | translate }}
      </span>
      <div *ngIf="activeFilterCount > 0">
        <span
          tuiStatus="#39B54A"
          class="gw-text-text-secondary gw-text-xs gw-font-normal"
          >{{
            'common.filters.activeCount'
              | translate : {count: activeFilterCount}
          }}
        </span>
      </div>
    </div>

    <div class="gw-flex gw-items-center gw-gap-2x-small">
      <button
        *ngIf="tableSettingsTemplate"
        type="button"
        class="gw-inline-flex gw-items-center gw-justify-center gw-cursor-pointer gw-rounded gw-p-2x-small hover:gw-opacity-80"
        [tuiDropdown]="tableSettingsTemplate"
        [tuiDropdownMaxHeight]="500"
        [(tuiDropdownOpen)]="settingsMenuOpen"
        (click)="$event.stopPropagation()"
      >
        <gatewee-icon
          icon="@phi.gear-six"
          size="16px"
          iconStyle="primary"
          weight="bold"
        ></gatewee-icon>
      </button>
      <button
        *ngIf="showReportDownload"
        type="button"
        class="gw-inline-flex gw-items-center gw-justify-center gw-cursor-pointer gw-rounded gw-p-2x-small hover:gw-opacity-80"
        [tuiHint]="'common.filters.generateReport' | translate"
        tuiHintDirection="top"
        [attr.aria-label]="'common.filters.generateReport' | translate"
        (click)="onReportDownloadClick($event)"
      >
        <gatewee-icon
          icon="@phi.download-simple"
          size="16px"
          iconStyle="primary"
          weight="bold"
        ></gatewee-icon>
      </button>

      <gatewee-expand-chevron
        [expanded]="isFilterPanelOpen"
        size="16px"
        class="gw-cursor-pointer"
        (click)="toggleExpanded()"
      ></gatewee-expand-chevron>
    </div>
  </div>

  <!-- Collapsible Body -->
  <div
    class="filter-body-panel"
    [class.filter-body-panel--open]="isFilterPanelOpen"
  >
    <div
      class="filter-body-inner gw-px-medium"
      [class.gw-pb-medium]="isFilterPanelOpen"
    >
      <!-- Loading skeleton -->
      <ng-container *ngIf="showSkeleton">
        <div class="gw-grid gw-grid-cols-12 gw-gap-6">
          <div
            *ngFor="let span of skeletonSlots; trackBy: trackBySkeletonSlot"
            [class]="getSkeletonSpanClass(span)"
          >
            <gatewee-skeleton></gatewee-skeleton>
          </div>
        </div>

        <div *ngIf="enableDateRange" class="gw-mt-6">
          <div class="filter-skeleton-period-label"></div>
          <div
            class="gw-flex gw-flex-wrap gw-items-center gw-gap-2x-small gw-mt-2x-small"
          >
            <div
              *ngFor="let _ of periodSkeletonItems"
              class="filter-skeleton-period-btn"
            ></div>
          </div>
        </div>
      </ng-container>

      <!-- Filter Fields Grid -->
      <ng-container *ngIf="!showSkeleton">
        <div class="gw-grid gw-grid-cols-12 gw-gap-6">
          <ng-container *ngFor="let filter of filters; trackBy: trackByFilter">
            <div [class]="getSpanClass(filter)">
              <!-- Text Filter -->
              <ng-container *ngIf="filter.type === 'text'">
                <gatewee-input-v2
                  class="filter-label"
                  type="text"
                  [(value)]="filter.value"
                  [placeholder]="filter.placeholder || filter.label"
                  [label]="filter.label"
                  [iconName]="'@tui.search'"
                  (valueChange)="onTextInput(filter)"
                ></gatewee-input-v2>
              </ng-container>

              <!-- Entity select: paginated async -->
              <ng-container *ngIf="isAsyncEntitySelect(filter)">
                <ng-container
                  *ngFor="
                    let scopeKey of [getEntityScopeKey(filter)];
                    trackBy: trackEntityScopeKey
                  "
                >
                  <gatewee-select-async
                    class="filter-label"
                    [label]="filter.label"
                    [placeholder]="filter.placeholder || filter.label"
                    [ngModel]="entityFilterModelValue(filter)"
                    [source]="getEntitySource(filter)"
                    [toOption]="toEntityOption"
                    [listOptions]="getEntityListOptions(filter)"
                    [idFromValue]="entityIdFromValue"
                    (ngModelChange)="onAsyncEntityModelChange(filter, $event)"
                    (selectionChange)="
                      onAsyncEntitySelectChange(filter, $event)
                    "
                  ></gatewee-select-async>
                </ng-container>
              </ng-container>

              <!-- Static select: small option lists (status, enums, …) -->
              <ng-container
                *ngIf="filter.type === 'select' && !isAsyncEntitySelect(filter)"
              >
                <gatewee-select-v3
                  [items]="$any(filter.data)"
                  class="filter-label"
                  [(ngModel)]="filter.value"
                  [placeholder]="filter.placeholder || filter.label"
                  [label]="filter.label"
                  (ngModelChange)="onSelectChange(filter)"
                ></gatewee-select-v3>
              </ng-container>

              <!-- Date Filter -->
              <ng-container *ngIf="filter.type === 'date'">
                <gatewee-input-v2
                  type="text"
                  [(value)]="filter.value"
                  class="filter-label"
                  [label]="filter.label"
                  placeholder="yyyy-mm-dd"
                  [iconName]="'@tui.calendar'"
                  (valueChange)="onTextInput(filter)"
                ></gatewee-input-v2>
              </ng-container>
            </div>
          </ng-container>
        </div>

        <!-- Period Section -->
        <div *ngIf="enableDateRange" class="gw-mt-6">
          <span class="gw-text-text-primary gw-text-sm gw-font-medium">
            {{ 'common.filters.period.label' | translate }}
          </span>

          <div
            class="gw-flex gw-flex-wrap gw-items-center gw-gap-2x-small gw-mt-2x-small"
          >
            <button
              *ngFor="let preset of periodPresets; trackBy: trackByPreset"
              type="button"
              class="period-btn gw-border gw-border-border-normal gw-text-text-primary gw-text-sm gw-leading-5 gw-cursor-pointer gw-whitespace-nowrap gw-transition-colors gw-duration-200 gw-bg-background-neutral-1 hover:gw-bg-background-neutral-1-hover"
              [class.gw-border-brand-primary]="selectedPreset === preset.key"
              [class.gw-text-brand-primary]="selectedPreset === preset.key"
              [class.gw-font-medium]="selectedPreset === preset.key"
              [class.gw-bg-background-neutral-2]="selectedPreset === preset.key"
              (click)="selectPreset(preset.key)"
            >
              {{ preset.i18nKey | translate }}
            </button>

            <!-- Custom Date Button: opens calendar only (no input) -->
            <button
              type="button"
              class="period-btn gw-border gw-border-border-abnormal gw-text-text-primary gw-text-sm gw-leading-5 gw-cursor-pointer gw-whitespace-nowrap gw-transition-colors gw-duration-200 gw-bg-background-neutral-1 hover:gw-bg-background-neutral-1-hover gw-inline-flex gw-items-center gw-gap-3x-small"
              [class.gw-border-brand-primary]="selectedPreset === 'custom'"
              [class.gw-text-brand-primary]="selectedPreset === 'custom'"
              [class.gw-font-medium]="selectedPreset === 'custom'"
              [class.gw-bg-background-neutral-2]="selectedPreset === 'custom'"
              [tuiDropdown]="customDateDropdown"
              [tuiDropdownMaxHeight]="customDateDropdownMaxHeight"
              tuiDropdownLimitWidth="auto"
              [tuiDropdownOpen]="customDateOpen"
              (tuiDropdownOpenChange)="onCustomDateDropdownOpenChange($event)"
            >
              <gatewee-icon icon="@tui.calendar" size="14px"></gatewee-icon>
              {{ 'common.filters.period.custom' | translate }}
            </button>

            <ng-template #customDateDropdown>
              <div class="filter-custom-date-dropdown">
                <div class="filter-custom-date-dropdown__body">
                  <tui-calendar-range
                    [value]="customCalendarValue"
                    (valueChange)="onCustomCalendarChange($event)"
                  ></tui-calendar-range>

                  <div
                    class="gw-grid gw-grid-cols-1 sm:gw-grid-cols-2 gw-gap-medium gw-px-small"
                  >
                    <div class="gw-flex gw-flex-col gw-gap-2x-small">
                      <span
                        class="gw-text-text-primary gw-text-sm gw-font-medium"
                      >
                        {{ 'common.filters.period.startTime' | translate }}
                      </span>
                      <tui-textfield tuiTextfieldSize="m" class="gw-w-full">
                        <input
                          tuiInputTime
                          [(ngModel)]="customFromTime"
                          [ngModelOptions]="{standalone: true}"
                          mode="HH:MM"
                        />
                      </tui-textfield>
                    </div>
                    <div class="gw-flex gw-flex-col gw-gap-2x-small">
                      <span
                        class="gw-text-text-primary gw-text-sm gw-font-medium"
                      >
                        {{ 'common.filters.period.endTime' | translate }}
                      </span>
                      <tui-textfield tuiTextfieldSize="m" class="gw-w-full">
                        <input
                          tuiInputTime
                          [(ngModel)]="customToTime"
                          [ngModelOptions]="{standalone: true}"
                          mode="HH:MM"
                        />
                      </tui-textfield>
                    </div>
                  </div>
                </div>

                <div class="filter-custom-date-dropdown__actions">
                  <button
                    type="button"
                    class="period-btn gw-cursor-pointer gw-border-brand-primary gw-text-brand-primary gw-font-medium gw-bg-background-neutral-2 gw-w-full sm:gw-w-auto"
                    [disabled]="!customCalendarValue"
                    (click)="applyCustomDateRange()"
                  >
                    {{ 'common.filters.period.apply' | translate }}
                  </button>
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Divider -->
  <div
    *ngIf="!showSkeleton && activeFilterCount > 0"
    class="filter-divider gw-bg-border-normal gw-mx-medium"
  ></div>
  <!-- Active Filter Chips -->
  <div
    *ngIf="!showSkeleton && activeFilterCount > 0"
    class="gw-flex gw-items-center gw-flex-wrap gw-gap-2x-small gw-px-medium gw-py-2x-small"
  >
    <ng-container *ngFor="let active of getActiveFilters()">
      <span
        class="filter-chip gw-border gw-border-border-abnormal gw-rounded-full gw-inline-flex gw-items-center gw-whitespace-nowrap gw-bg-background-neutral-2"
      >
        <span class="filter-chip__label gw-text-text-secondary gw-font-medium"
          >{{
            active.label || ('common.filters.period.label' | translate)
          }}:</span
        >
        <span class="filter-chip__value gw-text-text-primary">{{
          active.displayValue
        }}</span>
        <button
          type="button"
          class="filter-chip__close gw-inline-flex gw-items-center gw-justify-center gw-border gw-border-border-normal gw-text-text-secondary gw-cursor-pointer gw-rounded-full gw-transition-colors gw-duration-200 hover:gw-bg-background-neutral-1-hover hover:gw-text-text-primary hover:gw-border-border-hover"
          (click)="removeFilter(active.key)"
        >
          <gatewee-icon icon="@tui.x" size="10px"></gatewee-icon>
        </button>
      </span>
    </ng-container>

    <button
      type="button"
      class="gw-ml-auto gw-bg-inherit gw-inline-flex gw-items-center gw-gap-3x-small gw-text-text-secondary gw-text-xs gw-font-medium gw-border-0 gw-cursor-pointer hover:gw-text-text-primary gw-transition-colors gw-duration-200"
      (click)="removeAllFilters()"
    >
      <gatewee-icon icon="@tui.filter" size="14px"></gatewee-icon>
      {{ 'common.filters.clearAll' | translate }}
    </button>
  </div>
</div>
